import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";

export const faireRoutes: PermissionedRouteObject[] = [
  {
    handle: { breadcrumb: "Faire" },
    async lazy() {
      const { Page } = await import("../app/page");
      return { element: <Page hideHeader={() => true} /> };
    },
    children: [
      {
        path: "callback",
        async lazy() {
          const { FaireCallback } = await import("./callback");
          return { Component: FaireCallback };
        },
      },
    ],
  },
];
